import {ScopeTester} from './testers'
import {ReadOnlyFieldWithJson, Label, Divider} from '@/components/atoms'
import {
  CheckboxControl,
  DatePickerControl,
  DropdownControl,
  FileUploadController,
  SimpleButtonControl,
  TextAreaControl,
  TextInputControl,
  ReadOnlyFieldLinkText,
  ToggleButtonControl,
} from '@/components/molecules'

export const getScopesofAllElements = schema => {
  const listOfScopes = []

  function traverse(obj) {
    if (obj && typeof obj === 'object') {
      if (obj.scope) {
        listOfScopes.push({
          scope: obj.scope.split('#')[1],
          component: obj.component ? obj.component : '',
        })
      }
      if (obj.elements && Array.isArray(obj.elements)) {
        obj.elements.forEach(element => {
          traverse(element)
        })
      }
      if (obj.options?.detail && Array.isArray(obj.options?.detail?.elements)) {
        obj.options.detail.elements.forEach(element => {
          traverse(element)
        })
      }
    }
  }
  traverse(schema)
  return listOfScopes
}

export const customerRenderesHelper = scopeAndCompsList => {
  return scopeAndCompsList?.map(({component, scope}) => {
    switch (component) {
      case 'checkbox':
        return {tester: ScopeTester(scope), renderer: CheckboxControl}
      case 'simpleText':
        return {
          tester: ScopeTester(scope),
          renderer: Label,
        }
      case 'ReadOnlyFieldWithJson':
        return {
          tester: ScopeTester(scope),
          renderer: ReadOnlyFieldWithJson,
        }
      case 'ReadOnlyFieldLinkText':
        return {
          tester: ScopeTester(scope),
          renderer: ReadOnlyFieldLinkText,
        }
      case 'ReadOnlyDivider':
        return {tester: ScopeTester(scope), renderer: Divider}
      case 'datepicker':
        return {tester: ScopeTester(scope), renderer: DatePickerControl}
      case 'dropdownControl':
        return {
          tester: ScopeTester(scope),
          renderer: DropdownControl,
        }
      case 'FileUploadController':
        return {tester: ScopeTester(scope), renderer: FileUploadController}
      case 'toggle':
        return {tester: ScopeTester(scope), renderer: ToggleButtonControl}
      case 'button':
        return {tester: ScopeTester(scope), renderer: SimpleButtonControl}
      case 'textarea':
        return {tester: ScopeTester(scope), renderer: TextAreaControl}
      default:
        return {tester: ScopeTester(scope), renderer: TextInputControl}
    }
  })
}
